import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import {
  BulkUpdateItemRequestSchema,
  BulkUpdateItemRequestSchemaMdm,
  BulkUpdateItemResponseSchema,
} from '../shared/schemas/pricingItem.js';

export type BulkUpdatePricingItemPayload = z.infer<
  typeof BulkUpdateItemRequestSchema
>;
export type BulkUpdatePricingItemMdmPayload = z.infer<
  typeof BulkUpdateItemRequestSchemaMdm
>;

export const bulkUpdatePricingItem = defaultClient.mutation({
  url: 'planning-service/virtuals/pricing-items/bulk-update/',
  method: 'POST',
  requestSchema: BulkUpdateItemRequestSchema,
  responseSchema: BulkUpdateItemResponseSchema,
  useKey: true,
  processResponse(data) {
    return data;
  },
});

export const bulkUpdatePricingItemMdm = defaultClient.mutation({
  url: 'planning-service/virtuals/pricing-items/bulk-update-v2/',
  method: 'POST',
  requestSchema: BulkUpdateItemRequestSchemaMdm,
  responseSchema: BulkUpdateItemResponseSchema,
  useKey: true,
  processResponse(data) {
    return data;
  },
});
